module.exports = __webpack_public_path__ + "static/img_reciclaje-d2bdb0885e63fcc45b911424ac6a8604.png";